module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"reviews_count":"%{count} 則評論","review_description":"{percentage} 的用戶給予了 <b>{score}</b> 分的評價。"}}')
  delete Component.options._Ctor
}
